export default {
  mainCategoryProduct: 'ชื่อหมวดหมู่หลัก',
  categoryProductName: 'ชื่อหมวดหมู่สินค้า',
  coverCategoryProduct: 'รูปหน้าปกหมวดหมู่สินค้า',
  imageCategoryProduct: 'รูปหมวดหมู่สินค้า',
  detailCategoryProduct: 'รายละเอียดหมวดหมู่สินค้า'
};
